import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=40f4fd14&"
var script = {}
import style0 from "./Action.vue?vue&type=style&index=0&id=40f4fd14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports